import { ClassNameFunction, ClassNames, minutes, SlotKey } from "./types";

const slotClassName : ClassNameFunction = ({isHovered, isGutter, isSelected} = {}) => 
  `w-full h-full border border-gray-200\
  ${isHovered && !isSelected && 'bg-gray-100'} \
  ${isGutter && 'text-center p-1'} \
  ${isSelected && 'bg-blue-200'}`

const itemClassName : ClassNameFunction = ({isHovered} = {}) =>
  `absolute cursor-pointer z-10\
  w-full h-full border border-gray-300 rounded  \
  ${isHovered ? "bg-blue-200" : "bg-gray-100"}`

export const standardClassNames : ClassNames = {
  container: "h-full select-none",
  slot: slotClassName,
  item: itemClassName,
  dialog: "m-auto border border-gray-400 rounded-sm shadow-sm p-4 w-1/2",
};

export const msToMinutes = (ms: number) : minutes => {
  return ms / 1000 / 60
}

export const minutesToMs = (minutes: number) : number => {
  return minutes * 1000 * 60
}

export function calculateItemDuration(start: Date, end: Date, slotSize: minutes, max?: minutes) : minutes {
  const duration = msToMinutes(end.getTime() - start.getTime()) + slotSize;
  if(max) {
    return Math.min(duration, max);
  } else {
    return duration;
  }
};

export function calculateItemDurationFromKeys(start: SlotKey, end: SlotKey, slotSize: minutes) : minutes {
  return calculateItemDuration(new Date(start), new Date(end), slotSize);
}

export const timestampToHourAndMinutes = (timestamp: number) => {
  const date = new Date(timestamp);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
}

export const timestampToDayName = (timestamp: number) => {
  return new Date(timestamp).toLocaleDateString("en-US", {weekday: 'short'})
}
